import { Hero } from './components/Hero';
import { PsychologicalTrigger } from './components/PsychologicalTrigger';
import { BeforeAfter } from './components/BeforeAfter';
import { DiscoveryChannels } from './components/DiscoveryChannels';
import { SystemProcess } from './components/SystemProcess';
import { ConversionArchitecture } from './components/ConversionArchitecture';
import { SEOVisibility } from './components/SEOVisibility';
import { ValueComparison } from './components/ValueComparison';
import { CuriosityTrigger } from './components/CuriosityTrigger';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <PsychologicalTrigger />
      <BeforeAfter />
      <DiscoveryChannels />
      <SystemProcess />
      <ConversionArchitecture />
      <SEOVisibility />
      <ValueComparison />
      <CuriosityTrigger />
      <FinalCTA />
      <Footer />
    </div>
  );
}